import { DatasetAccessRequest, DatasetAccessResponse, DatasetAffectedProject, RevokeDatasetRequest } from '~/api/types';
import { formatFilterQuery } from '~/utils';
import { v2Api } from '../v2Api';

const tags = ['dataset-access', 'project', 'dataset', 'member'] as const;

const datasetAccessApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDatasetAccess: builder.query<DatasetAccessResponse, DatasetAccessRequest>({
        query: ({ datasetId, sort, order, search, page, size }) =>
          `datasets/${datasetId}/access-users?page=${page}&size=${size}${search ? `&search=${encodeURIComponent(search)}` : ''}${formatFilterQuery(sort, 'sort_by')}${formatFilterQuery(order, 'sort_order')}`,
        providesTags: tags,
      }),
      getDatasetAffectedProjects: builder.query<DatasetAffectedProject[], RevokeDatasetRequest>({
        query: ({ datasetId, userId }) =>
          `dataset-role/user-relation/revoke-affected-projects?dataset_id=${datasetId}&user_id=${userId}`,
        transformResponse: (response: { data: DatasetAffectedProject[] }) => response.data,
      }),
      revokeDatasetAccess: builder.mutation<object, RevokeDatasetRequest & { name: string }>({
        query: ({ datasetId, userId }) => {
          return {
            url: 'dataset-role/user-relation',
            method: 'DELETE',
            body: {
              dataset_id: datasetId,
              user_id: userId,
            },
          };
        },
        invalidatesTags: tags,
      }),
    }),
  });

export default datasetAccessApi;
